export default {
	keepAliveArr:"",
	loginName:"",
	// 获取面包屑导航数据，优先从localStorage读取，否则使用默认值
	get breadcrumb(){
		return localStorage.getItem('breadcrumb') ? 
			JSON.parse(localStorage.getItem('breadcrumb')) : 
			[{
				path: "",
				name: "订单管理"
			},
			{
				path: "/order",
				name: "销售订单"
			},
			{
				path: "/sfOrder",
				name: "顺丰下单"
			},
		];
	},
	set breadcrumb(value){
		// 面包屑导航数据持久化存储到localStorage中，便于刷新页面后恢复面包屑导航状态
		localStorage.setItem('breadcrumb', value ? JSON.stringify(value) : value);
	},
	//登录信息
	get loginMes() {
		// 登录信息持久化存储到localStorage中，便于刷新页面后恢复登录状态
		return localStorage.getItem('searchOriginLoginMes') || "";
	},
	set loginMes(value) {
		// 登录信息持久化存储到localStorage中，便于刷新页面后恢复登录状态
		localStorage.setItem('searchOriginLoginMes', value ? JSON.stringify(value) : value);
	},
}
